import useErrorModal from "./useErrorModal";

const useImageValidation = () => {
    const { showErrorModal, ErrorModal } = useErrorModal();

    const validateImage = (file: File): Promise<string | null> => {
        return new Promise((resolve, reject) => {
            const validFormats = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png'];

            if (!validFormats.includes(file.type)) {
                showErrorModal('Не удалось загрузить изображение', 'Допустимые форматы: .jpg, .jpeg, .gif, .png');
                resolve('Недопустимый формат файла');
                return;
            }

/*            if (file.size > 4 * 1024 * 1024) {
                showErrorModal('Не удалось загрузить изображение', 'Размер файла не должен превышать 4 МБ');
                resolve('Файл слишком большой');
                return;
            }*/

            const imageURL: string = URL.createObjectURL(file);
            const image: HTMLImageElement = new Image();
            image.src = imageURL;
            image.onload = () => {
                if (image.width !== 750 || image.height !== 422) {
                    URL.revokeObjectURL(imageURL);
                    showErrorModal('Не удалось загрузить изображение', 'Требуемый размер: 750x422 пикселей');
                    resolve('Недопустимый размер изображения');
                } else {
                    resolve(null);
                }
            };
        });
    };

    return { validateImage, ErrorModal };
};

export default useImageValidation;
